import { lookupCard } from "../../content/cards.js";
import type { CardId } from "../types/index.js";

export type InvestmentTotals = { progress: number; draw: number; block: number };

export function investmentTotals(cardIds: readonly CardId[] | undefined): InvestmentTotals {
  const totals: InvestmentTotals = { progress: 0, draw: 0, block: 0 };
  for (const cardId of cardIds ?? []) {
    const effect = lookupCard(cardId)?.investment;
    if (effect) totals[effect] += 1;
  }
  return totals;
}
